// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ltts-review-workspace.ant-layout{height:100%}.ltts-issue-control{font-size:40px}.ltts-issue-control::after{content:\"﹖\";font-size:32px;position:absolute;bottom:8px;right:-8px}", ""]);
// Exports
module.exports = exports;
